(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/product-form
 * -----------------------------------------------------------------------------
 * @version 0.0.8
 * @overview Dynamic product forms.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("product-form") === undefined) {
    class ProductForm extends HTMLElement {
        constructor(){
            super();
            this.form = this.querySelector("form");
            this.submitButton = this.querySelector('[name="add"]');
            this.idInput = this.querySelector('[name="id"]');
            this.redirectOnSubmit = this.querySelector('[name="return_to"]')?.value;
            if (!this.form || !this.submitButton || !this.idInput) return;
            this.form.addEventListener("submit", this.submitEvent.bind(this));
        }
        submitEvent(event) {
            event.preventDefault();
            this.loadingState(true);
            this.updateErrorMessage();
            this.submitButton.setAttribute("disabled", true);
            const formData = new FormData(this.form);
            fetch(`${routes.cart_add_url}`, {
                method: "POST",
                headers: {
                    "Accept": "application/javascript",
                    "X-Requested-With": "XMLHttpRequest"
                },
                body: formData
            }).then((response)=>response.json()).then((response)=>{
                response.status ? this.updateErrorMessage(response.description) : document.dispatchEvent(new CustomEvent("cart:updated", {
                    detail: {
                        type: "added",
                        items: [
                            response
                        ]
                    }
                }));
            }).catch((error)=>{
                console.error(error);
            }).finally(()=>{
                this.loadingState(false);
                if (this.redirectOnSubmit) window.location = this.redirectOnSubmit;
                this.submitButton.removeAttribute("disabled");
            });
        }
        loadingState(loading) {
            loading ? [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.add("loading")) : [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.remove("loading"));
        }
        updateErrorMessage(errorMessage = false) {
            this.loadingState(false);
            this.errorMessageContainer = this.errorMessageContainer || this.querySelector(".error-message");
            if (!this.errorMessageContainer) return;
            this.errorMessageContent = this.errorMessageContent || this.errorMessageContainer.querySelector(".error-message-content");
            this.errorMessageContainer.toggleAttribute("hidden", !errorMessage);
            if (errorMessage) this.errorMessageContent.textContent = errorMessage;
        }
    }
    customElements.define("product-form", ProductForm);
}



})();
